import { AnyAction } from 'redux';

import { tollActions } from '../reducer';

import { ActiveTollPoint } from '../../types';

export const setActiveTollSection = (activeTollSection: ActiveTollPoint): AnyAction =>
  tollActions.setActiveTollSection(activeTollSection);
